<div class="modal-header">
  <h5 class="modal-title"
      id="deleteRoomModalLabel">Delete room</h5>
  <button type="button"
          class="btn-close"
          aria-label="Close"
          (click)="activeModal.dismiss('Cross click')"></button>
</div>
<div class="modal-body">
  Do you really want to delete room {{ room()?.Room }} from location {{ room()?.HotelCode }}?
</div>
<div class="modal-footer">
  <button type="button"
          class="btn btn-secondary"
          (click)="activeModal.close('Close click')">Close</button>
  <button type="button"
          class="btn btn-primary"
          (click)="deleteRoom()">Confirm</button>
</div>